export const CREATE_EWAYBILL_RECHARGE  = 'CREATE_EWAYBILL_RECHARGE';
export const GET_EWAYBILL_RECHARGE_CUSTOMERS  = 'GET_EWAYBILL_RECHARGE_CUSTOMERS';
export const GET_EWAYBILL_RECHARGE_CUSTOMER_DETAIL  = 'GET_EWAYBILL_RECHARGE_CUSTOMER_DETAIL';
export const EWAYBILL_RECHARGE_CUSTOMER_REQUEST  = 'EWAYBILL_RECHARGE_CUSTOMER_REQUEST';
export const EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE  = 'EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE';